// @flow
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MuiRadio from '@material-ui/core/Radio';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
import { colors } from '../constants';
import Typography from './typography';

const useStyles = makeStyles({
  root: {
    padding: '2.5px 10px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    border: '1px solid #B1B1B1',
    borderRadius: '50%',
    width: 16,
    height: 16,
    backgroundColor: colors.white,
  },
  checkedIcon: {
    backgroundColor: '#3B99FC',
    border: '1px solid #3B99FC',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage: `radial-gradient(${colors.white}, ${colors.white} 28%, transparent 32%)`,
      content: '""',
    },
  },
  disabledIcon: {
    opacity: 0.5,
  },
});

type Props = {
  disabled: boolean,
  label: string,
  labelPlacement?: 'top' | 'right' | 'bottom' | 'left',
  value: string | number | boolean,
};

const labelPlacementToMuiLabelPlacement = {
  top: 'Top',
  right: 'End',
  bottom: 'Bottom',
  left: 'Start',
};

function StyledRadio(props) {
  const classes = useStyles();

  return (
    <MuiRadio
      {...props}
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={
        <span
          className={[
            classes.icon,
            classes.checkedIcon,
            !!props.disabled ? classes.disabledIcon : '',
          ].join(' ')}
        />
      }
      icon={<span className={classes.icon} />}
    />
  );
}

function Radio(props: Props) {
  return (
    <MuiFormControlLabel
      {...props}
      label={<Typography type="p">{props.label}</Typography>}
      labelPlacement={
        labelPlacementToMuiLabelPlacement[props.labelPlacement || 'right']
      }
      control={<StyledRadio {...props} />}
    />
  );
}

Radio.defaultProps = {
  disabled: false,
  labelPlacement: 'right',
};

export default Radio;
